import { Typography as MuiTypography, styled } from '@material-ui/core';

export const Typography = styled(MuiTypography)({
  alignSelf: 'center',
});
